import styled from 'styled-components';
import { Mobile, Tablet, Desktop } from '../utils/MediaQuery';

interface ExhibitionCardProps {
	name: string;
	title: string;
	description: string;
	images: string[];
}

const Container = styled.div`
	border: 1px solid #dee2e6;
	border-radius: 6px;
	width: 85%;
	margin: 0 auto 6rem;
	padding: 1.6rem 2rem;
	cursor: pointer;
`;

const Author = styled.div`
	strong {
		font-size: 1.2rem;
		font-weight: 600;
	}
`;

const Description = styled.div`
	margin: 1rem 0 2rem;

	strong {
		font-size: 1rem;
		font-weight: 600;
	}
`;

const Gallery = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
`;

const ImgWrapper = styled.div`
	width: 13rem;
	height: 9rem;
	margin: 0 auto;
	padding: 0.6rem;

	img {
		width: 100%;
		height: 100%;
		border-radius: 8px;
	}
`;

// Mobile Responsive
const MobileContainer = styled(Container)`
	width: 100%;
	box-sizing: border-box;
	margin: 0 auto 2.6rem;
	padding: 1rem;
`;

const MobileAuthor = styled(Author)`
	strong {
		font-size: 1rem;
	}
`;

const MobileDescription = styled(Description)`
	margin: 1rem 0 1.6rem;
	line-height: 1.5;

	strong {
		font-size: 1rem;
	}
`;

const MobileImgWrapper = styled(ImgWrapper)`
	max-width: 6rem;
	max-height: 4rem;
	padding: 0.2rem;
`;

// Tablet Responsive
const TabletContainer = styled(Container)`
	width: 100%;
	box-sizing: border-box;
	padding: 1.6rem 1.2rem;
`;

const TabletImgWrapper = styled(ImgWrapper)`
	max-width: 12rem;
	max-height: 8rem;
	padding: 0.4rem;
`;

function ExhibitioinCard({
	name,
	title,
	description,
	images,
}: ExhibitionCardProps): React.ReactElement {
	return (
		<>
			<Mobile>
				<MobileContainer>
					<MobileAuthor>
						<strong>{name}</strong> 작가
					</MobileAuthor>
					<MobileDescription>
						<strong>{title}</strong> - {description}
					</MobileDescription>
					<Gallery>
						{images.map((image, idx) => {
							return (
								<MobileImgWrapper key={idx}>
									<img src={image} alt='gallery'></img>
								</MobileImgWrapper>
							);
						})}
					</Gallery>
				</MobileContainer>
			</Mobile>

			<Tablet>
				<TabletContainer>
					<Author>
						<strong>{name}</strong> 작가
					</Author>
					<Description>
						<strong>{title}</strong> - {description}
					</Description>
					<Gallery>
						{images.map((image, idx) => {
							return (
								<TabletImgWrapper key={idx}>
									<img src={image} alt='gallery'></img>
								</TabletImgWrapper>
							);
						})}
					</Gallery>
				</TabletContainer>
			</Tablet>

			<Desktop>
				<Container>
					<Author>
						<strong>{name}</strong> 작가
					</Author>
					<Description>
						<strong>{title}</strong> - {description}
					</Description>
					<Gallery>
						{images.map((image, idx) => {
							return (
								<ImgWrapper key={idx}>
									<img src={image} alt='gallery'></img>
								</ImgWrapper>
							);
						})}
					</Gallery>
				</Container>
			</Desktop>
		</>
	);
}

export default ExhibitioinCard;
